import styled from 'styled-components';
import { themeOptions } from 'styles/theme';

export const StyledTextField = styled.div`
  margin-bottom: 20px;
  position: relative;

  span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;

    .required {
      color: red;
    }
  }

  .tf-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  .MuiOutlinedInput-root {
    padding-left: 12px;
    height: 40px;
    width: ${(props) => (props.width ? props.width : null)};
    background-color: ${themeOptions.palette.white.main};
    border: 1px solid ${themeOptions.palette.gray.border};
    border-radius: 6px;

    &:hover {
      box-shadow: 0px 0px 0px 3px var(--color-off-white);
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${themeOptions.palette.gray.border};
      }
    }
    &:active {
      border-color: ${themeOptions.palette.green.main};
    }

    .MuiOutlinedInput-input {
      padding: 0;
      width: 100%;
      border-radius: 6px;
      outline: none;
      appearance: none;
      background-color: ${themeOptions.palette.white.main};

      &:disabled {
        background-color: ${themeOptions.palette.gray.light};
      }
    }
  }

  /* required 경우, disabled style */
  .MuiOutlinedInput-root.Mui-disabled {
    background-color: ${themeOptions.palette.gray.light};
  }
`;
